export const AUTHENTICATION__API = {
  AUTHLOGIN: "/auth/login",
  AUTHRESET: "/auth/reset",
  AUTHREGISTER: "/auth/register",
  AUTHCODEVERIFY: "/auth/code-verify",
  AUTHACCOUNTVERIFY: "/auth/account-verify",
  AUTHRESETPASSWORD: "/auth/reset-password",
  AUTHFORGETPASSWORD: "/auth/forget-password",
  AUTHLOGOUT: "/auth/logout",
  SENDREGISTEROTP: "/auth/reg-otp-sent",
  SENTFORGETPASSOTP: "/auth/forget-pass-otp-sent",
  FORGETPASSWORDCODE: "/auth/verify-forget-pass-otp",
  EMAILCHECK: "/auth/check-email",
  OTPVIA: "/auth/otp/on",
  //twofactor
  VERIFY_TWOFA_LOGIN: "/auth/2fa/verify",
};

export const MAM__WALLET__API = {
  USERMAMWALLETSUMMARY: "/mam-wallet-history",
  WALLETTRANSACTIONHISTORY: "/social-wallet-transaction-history",
  INVESTORWALLETHISTORY: "/investor-commission-provide-history",
  MANAGERWALLETHISTORY: "/manager-commission-history",
  MAMWALLETINTERNALTRANSFERACCOUNT: "/mam-wallet-internal-transfer-accounts",
  WALLETINTERNALTRANSFERCODE: "/send-wallet-internal-transfer-code",
  CONFIRMWALLETINTERNALTRANSFER: "/confirm-wallet-internal-transfer",
  MAMWALLETWITHDRAWCODE: "/mam-wallet-withdraw-code",
  CONFIRMMAMWALLETWITHDRAW: "/confirm-mam-wallet-withdraw",
}

export const PROFILE__API = {
  FETCHPROFILE: "/profile/view",
  CHANGE_PROFILE_URL: "/profile/profile-url",
  UPDATEPROFILEINFO: "/profile/update-profile",
  IDENTITYVERIFICATION: "/profile/identity-verification",
  RESIDENCEVERIFICATION: "/profile/residence-verification",
  FETCHDOCUMENTS: "/profile/clientdocuments",
  DELETEDOCUMENT: "/profile/delete-document",
  BECOMEANIB: "/client/become-an-ib",
  ACCOUNTSUMMARY: "/client/account-summary",
  LIVETRADES: "/client/live-trades",
  PROFITLOSS:"/client/profit-loss",
  CHANGETHEME: "/update-theme",
  POPUPNOTICE: "/get-verifications",
};

export const BANKINFORMATIONS__API = {
  GETBANKINFORMATIONS: "/client/bankinformations",
  ADDNEWBANKACCOUNT: "/client/bankinformations/add",
  UPDATEBANKACCOUNT: "/client/bankinformations/update",
};

export const COUNTRIES__API = {
  COUNTRIES: "/countries",
};

export const AGREEMENT__API = {
  NOTACCEPTEDAGREEMENTS: "/fetch-admin-agreements",
  AGREEMENTHISTORIES: "/client-agreements-histories",
  UPLOADAGREEMENTFILE: "/upload-agreement-file",
};

export const CRYPTO__API = {
  GETALL: "/crypto-addresses",
  DETAILS: "/crypto-addresses",
  CREATE: "/crypto-addresses",
  NETWORKS: "/all-networks",
  OVYPAY: "/ovy-pay-networks",
  DELETECRYPTO: "/soft-delete-update-crypto",
  SENDOTP: "/sent-otp-crypto",
  CODEVERIFY: "/verify-otp-crypto",
};

export const PANEL_SWITCHER_API = {
  SWITCH_TO_PARTNER: '/switch-to-partner'
};

export const BANK__API = {
  GETALL: "/banks",
  DETAILS: "/bank",
  CREATE: "/bank",
  DELETEBANK: "/soft-delete-bank",
};

export const CITIES__API = {
  CITIES: "/cities",
};

export const STATES__API = {
  STATES: "/states",
};

export const FAQS__API = {
  FAQS: "/faqs",
};

export const COMPANYINFO__API = {
  COMPANYINFO: "/company/general-info",
};

export const TICKETS__API = {
  ALLTICKETS: "/tickets/all",
  DETAILS: "/tickets/details",
  DETAILSWITHCOMMENTS: "tickets/details/comments",
  CREATE: "/tickets/create",
  REPLY: "/tickets/reply",
};

export const TRADING__API = {
  CLIENTLIVETRADES: "/trading-account/live-trades",
  LEVERAGES: "/leverages",
  LEVERAGEACCOUNTTYPE: "/leverage-account-type",
  ACCOUNTTYPES: "/account-types",
  DEMOACCOUNTTYPES: "/demo-account-types",
  OPENTRADINGACCOUNT: "/open-trading-account",
  LIVEACCOUNTS: "/trading-accounts",
  DEMOACCOUNTS: "/demo-trading-accounts",
  MT5ACCOUNTDETAILS: "/mt5-account-details",
  TRADEHISTORY: "/trading-account/trade-history",
  ALLTRADEDETAILS: "/all-trade-details",
  TOTALLIVEACCOUNTS: "/total-live-accounts",
  OPENNEWDEMOACCOUNT: "/open-demo-account",
  LIVETRADINGACCOUNTS: "/live-trading-accounts",
  INVESTORACCOUNTLIVETRADES: "/investor-trading-account/live-trades",
  INVESTORACCOUNTTRADEHISTORY: "/investor-trading-account/trade-history",
  MANAGERACCOUNTBALANCECARDDETAILS: "/manager-account-balance-card-details",
  VIEWMANAGERDETAILS: "/view-manager-details",
};

export const TRANSACTION__API = {
  RECENTTRANSACTIONHISTORY: "/recent-transaction-history",
  TRANSACTIONHISTORY: "/transaction-history",
  TRADERTRANSACTIONS: "/trader-transaction",
  PAYMENTMETHOD: "/payment-methods",
  ACCOUNTSTODEPOSIT: "/trading-accounts-to-deposit",
  //deposit
  CASHDEPOSIT: "/cash-deposit",
  BANKDEPOSIT: "/bank-deposit",
  CARDDEPOSIT: "/card-deposit",
  //withdraw
  SENDCODE: "/send-withdraw-code",
  CASHWITHDRAW: "/cash-withdraw",
  BANKWITHDRAW: "/bank-withdraw",
  CARDWITHDRAW: "/card-withdraw",
  INTERNALTRANSFERACCOUNTS: "/internal-transfer-accounts",
  INTERNALTRANSFERCODE: "/send-internal-transfer-code",
  CONFIRMINTERNALTRANSFER: "/confirm-internal-transfer",
};

export const MAM__API = {
  INVESTORMANAGERACCOUNT: "/investor-manager-account",
  MANAGERLISTS: "/mam/manager-list",
  OPENNEWINVESTORACCOUNT: "/mam/open-new-investor-account",
  ACCOUNTTYPESANDLEVERAGES: "/mam/trading-account-types-leverages",
  STUSERNAMES: "/mam/st-usernames",
  OPENNEWMANAGERACCOUNT: "/mam/open-new-manager-account",
  MYMANAGERACCOUNTS: "/mam/my-manager-accounts",
  MYINVESTORACCOUNTS: "/mam/my-investor-accounts",
  LIVETRADESMANAGERINVESTOR: "/mam/live-trades-manager-investor",
  LIVEORDERSMANAGERINVESTORS: "/mam/live-orders-manager-investor",
  MANAGERACCOUNTDETAILS: "/mam/manager-account-details",
  UPDATEACTIVESTATUS: "/mam/update-investor-is_active",
  REMOVEINVESTOR: "/mam/remove-investor",
  ORDERHISTORYMANAGERINVESTORS: "/mam/orders-history-manager-investor",
  MANAGERACTIVERUNNINGORDERDETAILS: "/manager-active-running-orders",
};

export const PLATFORMS__API = {
  DOWNLOADPLATFORMS: "/download-platforms",
};

export const LEVERAGE__API = {
  USERLEVERAGE: "/user-leverages",
  ALLLEVERAGES: "/all-leverages",
  UPDATELEVERAGE: "/mam/update-user-leverages",
  UPDATEMT5PASSWORD: "/mam/update-mt5-password"
};

export const CHARTS__API = {
  PROFITLOSSCHARTHISTORY: "/live-trades-profit-loss-chart-history",
  CLOSEDTRADESPROFITLOSSCHARTHISTORY:
    "/closed-trades-profit-loss-chart-history",
  DASHBOARDPROFITLOSSCHARTHISTORY: "/dashboard-profit-loss-chart-history",
  SINGLEACCOUNTPROFITLOSSSUMMARY: "/single-account-profit-loss-chart-summary",
  MANAGERINVESTORPROFITLOSSCHART: "/manager-investor-profit-loss-chart",
  MANAGERINVESTORBUYSELLCHART: "/manager-investor-buy-sell-chart",
};


export const NOTIFICATIONS__API = {
  NOTIFICATIONS: "/client-notifications",
  MARK_ALL_AS_READ: "/mark-all-notifications",
  UPDATE: "/update-client-notification",
};

export const DEPOSITMETHODS__API = {
  DEPOSITMETHODS: "/all-deposit-methods",
  DEPOSITACCOUNTS: "/deposit-to-accounts",
  BROKERSBANK: "/brokers-banks",
  CREATEBANKDEPOSIT: "/create-bank-deposit",
  CREATECASHDEPOSIT: "/create-cash-deposit",
  CREATECRYPTODEPOSIT: "/create-crypto-deposit",
  CREATEGPAYDEPOSIT: "/create-gpay-deposit",
  CREATECARDDEPOSIT: "/create-card-deposit",
  GETPAYMENTSYSTEM: "/get-payment-system",
  NEEDSLIP: "/need-deposit-slip",
  INRRATE: "/get-inr-rate",
  CREATECRYPTODEPOSITOVIPAY: "/create-crypto-deposit-ovipay",
  PAYMENTNOTIFICATION: "/payment-notification",
  PAYMENTLOG: "/payment-log",
  CREATECRYPTODEPOSITOVIPAYQR: "/api/ovypay/create-payment",
  CHECKCRYPTODEPOSITOVIPAY: "/api/ovypay/check-payment",
};

export const WITHDRAWMETHODS__API = {
  WITHDRAWMETHODS: "/all-withdraw-methods",
  WITHDRAWACCOUNTS: "/withdraw-to-accounts",
  WITHDRAWOTP: "/withdraw-otp-sent",
  BROKERSBANK: "/withdraw-brokers-banks",
  CREATEBANKWITHDRAW: "/create-bank-withdraw",
  CREATECASHWITHDRAW: "/create-cash-withdraw",
  CREATECRYPTOWITHDRAW: "/create-crypto-withdraw",
  USERCRYPTOADDRESS: "/user-crypto-addresses",
  INRRATE: "/get-inr-rate-withdraw",
  OTPVIA:"/check-otp-via"
};


export const PUBLIC_LOGIN__API = {
  LOGINPAGEINFO: "/login-page-info",
  TERMSANDCONDITIONLINK: "/terms-and-conditions-link",
  COUNTRIES: "/get-all-countries",
};

export const TRADABLEBONUS__API = {
  CREATETRADABLEBONUSACCOUNT : "/open-tradable-bonus-account",
  TRADABLEBONUSACCOUNTINFO: "/tradable-account-info",
}

export const NOMINEE__API = {
  LIST: "/nominees",
  CREATE: "/nominees",
  UPDATE: (id) => `/nominees/${id}`,
  SHOW: (id) => `/nominees/${id}`,
};